import RrAdapter from 'global/thirdParties/rrAdapter';
import initializeEventListeners from 'global/thirdParties/rrTracking';

export default class RichRelevance {
	constructor(config) {
		this.config = config || window.RR_CONFIG || {};
		this.rrAdapter = new RrAdapter(this.config);

		initializeEventListeners(this.rrAdapter);
	}

	fetch(productZones) {
		this.replaceZones(productZones);
		return this.rrAdapter.run();
	}

	replaceZones(zones) {
		this.config.placements = [];

		if (zones && zones.length) {
			zones.forEach(zone => this.addZone(zone));
		}
	}

	addZone(zoneId) {
		if (!this.config.placements) {
			this.config.placements = [];
		}

		this.config.placements.push(zoneId);
	}
}
